import { render, staticRenderFns } from "./ComboOrLabel.vue?vue&type=template&id=38ce49e0&scoped=true&"
import script from "./ComboOrLabel.vue?vue&type=script&lang=js&"
export * from "./ComboOrLabel.vue?vue&type=script&lang=js&"
import style0 from "./ComboOrLabel.vue?vue&type=style&index=0&id=38ce49e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce49e0",
  null
  
)

export default component.exports